function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import Vuex from 'vuex';
import pathify, { make } from 'vuex-pathify';
import VuexPersistence from 'vuex-persist';
import forms from './forms';
var vuexLocal = new VuexPersistence({
  reducer: function reducer(state) {
    return {
      forms: {
        form: state.forms.form,
        submissionRecipient: state.forms.submissionRecipient,
        totalSteps: state.forms.totalSteps,
        formId: state.forms.id,
        formName: state.forms.formName,
        formOccupation: state.forms.form.occupation
      }
    };
  },
  storage: window.localStorage
});
Vue.use(Vuex);

var state = function state() {
  return {
    ctr: '',
    countries: [],
    showCountrySelector: false,
    showConfirmPanel: false,
    needLocation: false,
    loading: false
  };
};

var mutations = make.mutations(state);

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  currentCountry: function currentCountry(state) {
    return state.countries.find(function (_ref) {
      var value = _ref.value;
      return value.toUpperCase() === state.ctr.toUpperCase();
    }) || {};
  }
});

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  updateCountryCode: function updateCountryCode(_ref2) {
    var commit = _ref2.commit,
        rootGetters = _ref2.rootGetters,
        dispatch = _ref2.dispatch;
    var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CH';

    if (code) {
      code = code.toUpperCase();
      commit('SET_CTR', code);
      commit('forms/SET_FORM', _objectSpread({
        ctr: String(code)
      }, rootGetters['forms/form']));
      dispatch('forms/loadProducts');
    }
  },
  updateCountryPage: function updateCountryPage(_, payload) {
    // eslint-disable-next-line no-restricted-globals
    window.location.href = payload.value || payload;
  },
  updateCountryList: function updateCountryList(_ref3, payload) {
    var commit = _ref3.commit;
    commit('SET_COUNTRIES', payload);
  }
});

export default new Vuex.Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
  modules: {
    forms: forms
  },
  plugins: [vuexLocal.plugin, pathify.plugin]
});